import {createReducer, on} from '@ngrx/store';
import * as DocumentActions from './document.actions';
import {DateTime} from "luxon";

export interface DocumentState {
  refresh: number;
}

export const initalState: DocumentState = {
  refresh: DateTime.now().toMillis(),
};

export const documentReducer = createReducer(
  initalState,
  on(DocumentActions.refreshDocuments, (state) => ({refresh: DateTime.now().toMillis()})),
);

export const documentFeatureKey = 'document';
